<div *ngIf="this.chatResp?.chart" echarts [options]="this.chatResp.chart"></div>
